import img from "../images/Microsoft-Certificate.png"
import img2 from "../images/GitHub-Certificate.png"

export const Bio = {
  name: "Rahman Tamim",
  roles: [
    "Web Developer",
    "Content Writer",
    "SEO Expert",
    "Digital Marketer",
    "Graphic Designer",
  ],
  description:
    "Microsoft, GitHub, and LinkedIn Certified Web Developer, with SEO and Digital Marketing certifications from LinkedIn and Google. I deliver fast, high-impact websites combined with expert SEO, Content Writing, Copywriting, Digital Marketing, and Graphic Design — crafted to attract traffic, engage visitors, and convert clicks into customers. Fueled by creativity, precision, and clear results, I turn your vision into a powerful digital presence.",
  github: "https://github.com/rahmantamim11",
  linkedin: "https://www.linkedin.com/in/rahmantamim10",
  resume:
    "https://drive.google.com/file/d/1cENsDKqOb2A8EA7hJw64kac2u84akBbC/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/rahmantamim10",
  insta: "https://www.instagram.com/rahmantamim11",
  facebook: "https://www.facebook.com/rahmantamim11",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "React Native",
        image: "https://static.cdnlogo.com/logos/r/18/react-native.svg",
      },
      {
        name: "Next Js",
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACTklEQVR4Ab1XAaQqURB9DyohSykREpRIQSAlBCoECKUFCSRCBBEAaSEABQEoCIEASCwAUICALgCo83do0//9v819XX845O7VnDkzOzP7JWGaBd3C3IJpQVjAHeJ+Rs9a97vKLGrBsB1KgMhEP3FMUUwt4ENMfxr1yQIU4SSjRkbeOZtERmHk6pXQVDlnkHh9S+QLTm1hkiz4n/gzFQuny9FoFLquE+i34x+n02k0m00UCoV3BIzn3MMJrVYLtp1OJ0cS/X4f5/MZhmG8IyDsWtDfEaDIn2232/3zbrvdxuFwwGg04qRBt+VnETBNE0IIkE2n07/erdfrWK/X6Ha73Hb9ZXII3G43ivy3dNRqtZe7lUoFs9mM6oBDwCQCgquALT1FT3a5XF7qIZ/PYzgcolqtcggIIgBZAgRKB6lCRalp2uM8k8mAVMrlchwC+DEBipycE4n5fP44j8ViKJVKSCaTbAJCpgaez4vFIsjoWa/XA50FAgEkEgmEw2F2CkxZBZ5Br5tt1ITcbjd8Ph88Hg+7CBefECCsVitS4aVJcV9D/VMCVITk/Hq9YrPZyBBo2a1YMGvAcQYcj0cCtWMugcdYNhjDiBrP25mx3++x3W6RzWZZ8isfxzQLlsslJpMJpYY5jhkqcOH1ejEYDDAej9FoNOByuZxGsfqVzC7KTqcDSkkqleKsZOqX0mAwiHK5DGrJfr+fs5SqX8sjkQji8ThCoRC+v78Za7l6JagrUh3YkUuZpqgwDaecc9VYSDoV5Fg+at7n+eLN57kuE/EvzHr/Kvs31aYAAAAASUVORK5CYII=",
      },
      {
        name: "Tailwind CSS",
        image: "https://www.cdnlogo.com/logos/t/58/tailwindcss.svg",
      },
      
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "Material UI",
        image:
          "data:image/png;base64,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",
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Express Js",
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAY1BMVEWCgoL////l5eXk5OTm5ubu7u74+Pj19fXx8fH7+/vr6+t+fn52dnZ7e3t8fHzz8/OGhoaTk5Pa2tq3t7e7u7utra3Q0NCZmZnFxcWkpKSMjIzKysqpqanX19e/v7+dnZ1ra2tH/Sn9AAASPElEQVR4nOVdbZuyKhBWwTcErcxqa7fO//+VB9RKGF6tdvWc+bLPNY+m48DMzc0AURzHWYKTjP9FOEn5nzTBaKJNPLW5UYtxQozawqYtH1o8V4ui/4eFKEG9hcn4fgmaqU2S0ZaHNndpi0Fbjlr8Ni0atVGWZXmapjn/y/8U/E/B//6etnmnttFoI/4BemcgxUVBWuLS8iaES/6XENLwPw1vSpPPngzXPj67TYtDtIhrI6ztZm/pkuKZDbcpLgt0uV73+7b74tJ1bdterztUZDgl5Se6JJpoP+ZD/uNNnKNTdztHlFJWV7LUjCuj8609oIx/hfRzPvxI3yqanBzaIzeNGxbZpKq4pdG2PeBcdKKXepyhH747lgotut4iyuymKYYyGt1O6aRpvi+WvrXzYZKSXbehDscZrKxp1F1wms7sfNZ8iAa/oLGbIeSjJRrt9RjmO+hLtj31HkDD+6GhS6Kxm3losaKNAs0yG9uQ042+Yt1dano8lS+ahT6QLUjH2BvMG42sOxKTt2WLV8MLwqT42b7FfU+p6PYkUunrQSd6PUU0pK3e576nsKgl8euJQ84W4ck/IWj/UmyxScW+EQlO/gi9M1vkqPuYfYONXfGWbDHbh+1H7Rts3AdCNUX7Qj/M8lNUf9g+IXV0KssX+uH8WIo2n4gvOmFnFAjVprF0bj7Mvukv2SeEfudkbj6cBdUScnhz/nMJ745kHoCbh0uz2286cBB2K3NvqDbFpeHZAse/7cBBKnpKfZvmS1wbSY6/78BB2FGid/wAXPAYvznMGvy9R6rqEH+Ya0ua6185cBDaEm1eQO/i2vDxt3KgSdgRuUmA2Vwb2W3+roXepdqgIAAX0g/zw187cBB2yD/DtaXt33bBp/DO6IBqs0ZP6dcyPCiEfZXeAM4b0xTH3xhH+Aq72aHaFNP4RRqcnP8+xkylOqO3ZguMFhBEZRlCqgmqhXJtJdr8tUE6yd/GtZVkaQ4cJS0n75tqE0fqw7VhtFADo2j3Fq4NL7OJ9rJ5C9eWLNdAHlHdAM7ZD/OFpQlZqm2hQrU8kGtLj0s2kJt4dAE4Rz5Mv5aEZHRS6wCcP9eWt8vBoiahJzuAs0YacljKaMIm9IKtkcaWLXbL96AQtsMWAGcZHyZ4wXlCkk0410Z6Vm3hYfQp1TZWoJoX19Zc19FGhbCOhI+e8M8aosxd6CGYa8PJX790mFTBXFu8mk44SHUsIdeW27i2VWTCqdALCeHakmxtBnITrflQ5drIbV1ttJctCeDaVtdGhdCDPtLossUK26gQmjW+XNv3Ctsol+o7s3NtZEwcGVqnC7kTf0YriJ1ry9cCuKGc/bi203rwqCrs4sW1/fVrviKVB9fWtEtnZmxSt42La0vQetuoELZzcW2kW2emuEvVObm2dbtQpH0719bs1+1CkfaJbWyBydpdyIONNVuQdu0u5E5sCeTaSErEGJ+kxfoN5CYWI9c2ADh59PQT3EjF4roqOh+3x/OG/5u5y/oAJvT9qup1GwO6ZD+xmWvbej5sfCSj5/ZARAMfJCM/+1tlLz5lRawI8QP61Zd649Fw5TZOTFyb57PGV2VfP6X6UCGojay/A27wI2Yr9TbjrBFFyXQEnOcj15ZnTUC2p+eDzrpRdluzjdAX8dbjuTRRbjLzuVVX5gPXlitcm3+qoEdksa935Nn4Y/SiXty42w5rlXtyy8uy2JAPfYdNbLNz2CfkZHxtmqrXXpxPPqu32PzODgau7eZnIL162Ce+4tk0StmAa13tlKrxyTp1W91kru1BknrFmaqv8PCTzvCL9bd6pYP7omqn3zmuR4lubHH1iTMUxgmLXAwvAt7YEjciTXDKHK262uPHngVPH6am9CK92j7EQPO3Zo16pY2DBoni7HrPSYUGH+OTYYzvkwxhGJxrIogcpZlaoGrgdtdPUJJDrs1j0h42LrcYmh+I/uauBS51dML+nl0Os4U73fd1HUDK5HDat/vrAWW6/zZlDQoyjomHVt1ty4R3qbocjp6cLCnr4Ovj9nzf1YND8HOrAg8hX/o3ZwDy6R8LEoUPAoo2mcy1cZDjJLqrLXj3n7OCsistmNN/O/h72lcAXd+viIlibpTEtRVO+oKpjRCddW+kATzY0BUBcuhgtBHJWxKPTtj/uPgwUj5sDG3pIaDfGFdfwJRpYA5AjNRkgUppy65M+LhPgAqJa8t97phIaUbWfKiqAk/TtaqFIGOBj+DVCe+/PeXasCsbKnGhtI/M1RczLCcCTTDeyxeCRLH3H/7s5P3asGNJk9pnXNQDxfL1hkANEYTcTtVE4dkJhdQnOVs4SbbQtkJlWGYigKgK49OpDWqi8O2EQqqWTLk20thBKZNzgE/AVj6/6TIwkJoMUoGH/Tshl2Mjc232q2Xo6zXMUrrQyQA71Qg2YcNALw0s55W5Nvv4rJZ7oRPZ9yI3sdKYW1SIkN+vVEFPQCfsfziXuDY7oqH59EmepSiKC4zVDwCVjYNKNR6XgVwuv//OteV52pgake5d/VyoRhHz0AUMpPqSOpAoQgvt6lPT2zbEUvusIZPgjHdjUbqY0UKA6HtvqXYH19RX3VAbPeRDYiWhqPQoF7ybvLrnffRHsYb3AzWNzKiAuZGnhYjYWp7Ckvh/Sya9uYUxrKV+Lr6GmihCO6GQ82jhEEttV9bSwDcgolVS80vNN4KBVKkmiqBMeJfp2MIYy4XIDSZkklhOo5YLmYPg8oej0x8tJ1xbYbNQ7k4hdZkydLPdCQdSU5lXhkaLwYeEkKK0/sRRelpISZgchK3eB4ThRLJ5FT4MpYSk5RBLbfMGlZyYgibgpHhhnX6t5O8oycyS8/7pYyzFV8tXklF3wzb+EkndyxJqxGO0RJ6Ques+6v3UQttEjmsizVcsnK8QMJAaZXYtaHWNH1xbaesicC5srji6MJyR6r/L7OKJ6ppz2/IhllotfJeBrioBzeRwPLsTit/bk2c+tI3w32ehk87TcK0vLL7iFj65Nhvwrt9mobMcSdMVZ9snIBV5cG3E9nX13WOOOOGQpp3aA7D718ZY+ksWWgeh/TvpbpptYj+svVtoA1RggDpbXPUIeug2O9TcLRR8VGHz4fv6ocNCOKXYiyONWiz8ikWx3sDT2CIN0z53loX2dzU1lrkp/x5p+mxhs1DOFqL8dqZgeywFjNRDunkZo+rSJ9dmzYfSAJz8Q2eL3UDLDLov96VYyDP+nWtrbBYyaQrihehtfx0wSfPyQ6s2e3Bt1vYjD/I+ZqHFQHNdjv0nReTyGVvINI2V75gvgP5VTJyz4vM+thgstI2AZTrzIxaqiaJQYcacEUY9+rCPpdZamvkshreoiWILaq9mpAy2688eGCy03i8nRJ/asFBRh6AnBkF4+D4yFBFPrk1OVB9YNaTSv31BLcj/wSmDNhOuzTq55k1dzxSQKHpbAIXqUUgsC82eXBvC1jeQwkBQtbuXqIliDHugnQanjOnMTGptAnKDmWuISdRCnUfGBe00MGWcpZkZ+9yTVA0V0hHZVAyXqCOKs/F/Aj/ubfRhURRNXlpBsdwRDTVc2hsvu4noiSjVU5MpCrVkJSxlVG3JbbtzbaaSnvFamVzwX1gj5xntJWqikLu56sSQGRp2kOra7F9HflP/SWDpy2hDFFMLSqSAUIN6z4BlS2Ief1LXZq/FkJup92PkGKJjaUCiUJwEeI2AlMGjx7OuLcHEfrUM3HzHFzK41IEhlSGBfVx1YsCeJESU85bJ3UI7GFN6ix//JY9pdRVboKITJK0KtFPvMoIjCalrUx/ks5uiMl+mwUKgm2mwJ+TfPA2c1rWVOQc3jtpEqtQS+MyrO9wDE4U+D6kW+i3t4TFMrCEts0ddmyPLgfIz5wkClVw0rQnAYFJLOzCD8dQvZYgZdmkNqatGGGRf05qm0b6NUhUO469viTpsp36xPFbWkDYu0AdQ4o/lMCtQ6g1dCBKFOSWrT8492ulQ5/3g2ji4yVyTCrCyPm4N/CCLADMIG6Baom4mD2A79UgZ9bXhiE3Y9lhR4kxymqmvvGPAkRWN4Iw83C8Flv5b1j2B9Q3ulEF3GKwKchMwunXNh+/oeRJuzejmW7O+FDZA4BcrbAT+dqeMTQbXkDpHRZpFM4Mnd5e9OMq42192aoFaLw0MIaBX258M5hVdA5yqfZwNxWMp7tcfYjc9UQetrnwKbB2gxTs+L2ynjtlvdhlOXcaTNaQYu9MMm2Ui3BAcLIJzDvzgMjA75mDJzDWkzDa7oJccLs2AcxTOB8Nb7CsTpmtIB66tLEjqnITmUp/1iwyNomsZteoQD2IEVNlaU0Z9SnNu1IRrG3Yc8Bsx+KzFf4huFAJ+wWtIDdvptyW/GHYc8FuPT8EKCaPkuhPaYAL3eqxm+s2Y3/r1+LodeDz3VKgA9WCQkxbzgEThSd7BdmpMGYKTePqw59rynGOcwrsmgG08ljxfIu0HA4nCm/aB7dSUMmg+GDXl2ob92vypUFZdtcn9LunecAgySBT+82bem6KIzbAM+7WFMPbifHBDvSQ+Gc+whoWyATuJwnaqJ9Aowsb92sL2GKppddwfyMSZOTmITYYsrV19x6DFTGApcqzdXm4bg/3a7uePkfBtL8UidVZtztvteRP1/7b65HzcyhL2tI1y91aHUtipX7rN/RhPuLZxvzYHqbgS+d/t11aWgmsjOf/L/6Tr33OPCahWlg23JisnXNu42/VaN0l+ipjPtZ6N8B/Z+9JyNgJZuRN7jk3esXzk2sY/Ta6hHNYkrCgGa5pC5dri+9kItvUzi5f66nM2wpqbaeV1NsLa9/NWz0Z4cG09yBFbZJTzClaXIBsyQjWMn7EUno1gX424ZKE/WDkbQbPbNcK8wfov116UiLMR7hYihWsry4L/fQA4n920Figsf0C1Jwwt5WwxJn+yosOsnsLGrQS9ziFNV3nOTBpyDumHyrk/KfTR+RQfTri2CYDLV5cU2amUrNBzbRN3ktWd2dXEmlPJrOeQ/vU7B0oSfA4pXtWZT/ez80znkHJbe65NAnAzquP/TEQZhQTVjFybfJjHarpiP/8uQTWQLTDSWJgs+bxqSTYAqk0tlLk2CcClazlLFqUqVDNzbUryX0W0EdMZKlTzOYc0WdWZzrZTq60+TMnX0k1kw7ncifkcUhnkKACuycuFY/DqFuugmpVrUwEcLIdZkFRnPVTzPZd7mHNbcs7YTDpfEnIOqQzg/toMi5igmoVrGwGcpHXVD/+dZCXWQjVs59pgg13qIUm5Eaq5uDbVwnKJDbXiBhqhmotrgwAOb5bmxuqMSzNUc3FtcvIf4s/CkoZIExaoFpYtBm0xa3PGT0l9hHnBmi2sPrwDuNtyABy7OaCamWtrLAAu3i9lpEH3LqjmwbWNWtmd12WYKBbFOaCaF9em0ZKfJfTFeufufD5cm1aLkfGUqt8Sdu7fzAHVDFybB4CLy++/bam0Hd5MhmpYhWoTrSVbID0D9/5tIwKk3yzHA6r5cW0GLbEci/dhYVuEVVCmh2qeXJsEiCba8o/SBt0X/Ttk2jcL5dqQTUt2f+BGdu6PzEy8oJo316YHcFxL9HX4n5OKtinW5AWPbGHn2sza/PabTZXeUqIHZU5tZIRqDm2TGZYbfEBYdMkAiNRDS6jVcW2q4wzaIr5algK/Typ2JcQIyt7BtVm0PP9/2saKdplf53uBazNoxe/ku9tHbazokUwDqATK9FoL1yaSKYRqd21u0hZfH7OR+6+IG/AOE1DmAeAgE2UBcIlWS1BHPxFzatohXQbwgWqhXJtdy7Njetm82ZEV3Vwx8QBl7+LaTADufm0c777e6EhGv3ZxagNlZqimal+MNA9tgsv4YFzQFSQ8uhxSgsNjiiHSvJQtplrx62i/pS/lyKqm22s2Ly+8zLX5aHmXJGKXhXqOlVXFou6EyDCE9wVl7+HaQrR5nmXodItYkJUVo9HtuhNbbweCMqfWiLyDAJxGuzt9b/stM5ztkhu37U48WDV4Bih7L9cW0iV5b2jiHJ262zmilD12B6meu4RQGp2P3QWJ0Jc+u87zF5LZnW821+YVViVtI5Ja2aDLdb/ft93X7fbVdW3b7q871GT8P6VRrQcoCw6req5tJoC7ayGk6ktXSJ/BY5KSHgoRy7VWUBYG4KxMVBCAy21aArVyI9RrZ0O1l7g2K4BLVG0+aIlR+yoo+wjX9prWC369rn0AuE9HmlTu+3rtRyPNv+c/cIe0nzmlAAAAAElFTkSuQmCC",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
      {
        name: "Firebase",
        image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
      },
    ],
  },
  {
    title: "Graphic Design",
    skills: [
      {
        name: "Illustrator",
        image:
          "https://www.cdnlogo.com/logos/a/86/adobe-illustrator-cc-2019.svg",
      },
      {
        name: "Photoshop",
        image: "https://www.cdnlogo.com/logos/p/64/photoshop-cc.svg",
      },
      {
        name: "Canva",
        image: "https://www.cdnlogo.com/logos/c/7/canva.svg",
      },
    ],
  },
  {
    title: "Content Writing & Digital Marketing",
    skills: [
      {
        name: "Seo Optimized Content Writing",
        image:
          "https://www.cdnlogo.com/logos/g/16/google-marketing-platform.svg",
      },
      {
        name: "Web Content Writing",
        image:
          "https://www.cdnlogo.com/logos/g/16/google-marketing-platform.svg",
      },
      {
        name: "Blog/Article Writing",
        image:
          "https://www.cdnlogo.com/logos/g/16/google-marketing-platform.svg",
      },
      {
        name: "Product Description Writing",
        image:
          "https://www.cdnlogo.com/logos/g/16/google-marketing-platform.svg",
      },
      {
        name: "SEO",
        image:
          "https://seeklogo.com/images/T/Target-logo-9FE48EBE3B-seeklogo.com.png",
      },
      {
        name: "SEM",
        image:
          "https://www.cdnlogo.com/logos/g/16/google-marketing-platform.svg",
      },
      {
        name: "SMM",
        image:
          "https://www.cdnlogo.com/logos/g/16/google-marketing-platform.svg",
      },
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "Strapi",
        image:
          "https://static.cdnlogo.com/logos/s/41/strapi.svg",
      },
      {
        name: "Contentful",
        image:
          "https://seeklogo.com/images/C/contentful-logo-C395C545BF-seeklogo.com.png",
      },
      {
        name: "Netlify",
        image:
          "https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png",
      },
      {
        name: "Wordpress",
        image: "https://www.cdnlogo.com/logos/w/94/wordpress-blue.svg",
      },
      {
        name: "Shopify",
        image: "https://www.cdnlogo.com/logos/s/88/shopify.svg",
      },
      {
        name: "VS Code",
        image: "https://www.cdnlogo.com/logos/v/83/vs-code.svg",
      },
      {
        name: "Microsoft Office",
        image: "https://www.cdnlogo.com/logos/m/39/microsoft-office-2013.svg",
      },
      {
        name: "Figma",
        image: "https://www.cdnlogo.com/logos/f/43/figma.svg",
      },
      {
        name: "Vercel",
        image: "https://www.cdnlogo.com/logos/v/78/vercel.svg",
      },
    ],
  },
];

export const certificate = [
  {
    title: "Career Essentials in Software Development by Microsoft and LinkedIn",
    skills: [
      {
        image:
          img,
      },
    ],
  },
  {
    title: "Career Essentials in GitHub Professional Certificate",
    skills: [
      {
        image: img2,
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    role: "Co-Founder & Managing Director",
    company: "Algrowvert",
    date: "Februray 2022 - Present",
    desc: "As the Co-Founder and Managing Director of Algrowvert, I am actively involved in shaping the company’s vision and strategic planning to establish it as a leading force in the industry. My role includes Front-End Development, Team Leadership, and Digital Marketing, where I contribute to driving growth and enhancing our market presence. I also oversee content creation and graphic design, ensuring consistency with our long-term goals. Through innovation, collaboration, and a forward-thinking approach, I’m dedicated to positioning Algrowvert as a giant in the industry, making a lasting impact on the market.",
    skills: [
      "Leadership",
      "Html",
      "CSS",
      "SEO",
      "Content Writing",
      "Digital Marketing",
      "Graphic Design",
      "JavaScript",
      "React Js",
      "Next Js",
      "Social Media Strategy",
      "Video Editing",
    ],
  },
  {
    id: 1,
    role: "Front-End Developer | Content Writer | SEO Specialist | Graphic Designer",
    company: "Aurea CV OÜ",
    date: "June 2024 - July 2025",
    desc: "Built fast, responsive websites using HTML, CSS, JavaScript, and modern frameworks, Created SEO-optimized content and applied on-page SEO strategies, Designed branded visuals aligned with UI/UX principles, Improved user engagement and performance metrics",
    skills: [
      "ReactJS",
      "Next JS",
      "NodeJs",
      "Material UI",
      "Tailwind CSS",
      "HTML",
      "CSS",
      "JavaScript",
      "MongoDB",
      "Firebase",
      "Github",
      "Netlify",
      "Vercel",
      "SEO",
      "Content Writing",
      "Digital Marketing",
      "Graphic Design",
      "Social Media Strategy",
      "Video Editing",
    ],
  },
  {
    id: 2,
    role: "Frontend Developer",
    company: "DesperateHub",
    date: "June 2020 - January 2022",
    desc: "I am focused on developing the front-end of the web application using a combination of ReactJS, NextJS, Material UI, and Tailwind CSS to create responsive, modern, and visually appealing user interfaces.",
    skills: [
      "ReactJS",
      "Next JS",
      "NodeJs",
      "Material UI",
      "Tailwind CSS",
      "HTML",
      "CSS",
      "JavaScript",
      "MongoDB",
      "Firebase",
      "Github",
      "Netlify",
      "Vercel",
    ],
  },
  {
    id: 3,
    role: "Content Writer",
    company: "Synacto",
    date: "June 2021 - May 2023",
    desc: "As a Content Writer at Synacto, I thrived in a fast-paced and innovative environment, where creativity was at the heart of every project.",
    skills: [
      "Exceptional writing skills with a keen eye for detail",
      "Proficiency in crafting content across various formats and platforms",
      "Ability to adapt writing style to target different audiences",
      "Strong research abilities to gather information on diverse topics",
      "Collaboration and communication skills to work effectively with teams",
      "Understanding of SEO principles and best practices",
      "Time management and prioritization to meet tight deadlines",
      "Creative thinking to generate innovative content ideas",
    ],
  },
  {
    id: 4,
    role: "Graphic Designer",
    company: "Gadget 360 Degree",
    date: "May 2019 - January 2022",
    desc: "During my time as a Graphic Designer at Gadget 360 Degree, I played a key role in defining and enhancing the company's visual identity, ensuring that every design element resonated with the brand's core values and audience.",
  },
];

export const education = [
  {
    id: 0,
    school: "National University",
    date: "2018 - 2022",
    grade: "3.22 CGPA",
    desc: "I have completed my BBA from National University Bangladesh with a major in Marketing.",
    degree: "BBA",
  },
  {
    id: 1,
    College: "Uttar Kattali Alhaj Mostafa Hakim Degree College",
    date: "2018",
    grade: "A",
    desc: "I completed my HSC at Uttar Kattali Alhaj Mostafa Hakim Degree College,Chattogram, Bangladesh.",
    degree: "HSC",
  },
  {
    id: 2,
    date: "2016",
    grade: "A",
    desc: "I completed my SSC education at P H Ameen Academy, Chattogram, Bangladesh.",
    degree: "SSC",
  },
];

export const projects = [
  {
    id: 4,
    title: "LearnCoin",
    date: "October 2024 - December 2024",
    description:
      "I’m thrilled to share my latest project, Learncoin – a blockchain education platform designed to bring cutting-edge learning to users around the globe. Built using Next.js, Learncoin offers a fast, dynamic, and seamless experience, showcasing how modern technologies can drive education in the blockchain space. For content management, I turned to Contentful, a robust headless CMS, to ensure efficient handling and delivery of dynamic content. This decision provides scalability and flexibility as the website continues to grow and evolve.The development process was both challenging and exciting, as I integrated SEO optimization and user-focused design to ensure smooth navigation and high visibility on search engines. From creating interactive components to ensuring the site is mobile-friendly, every element was crafted with the user experience in mind. I’m incredibly proud of how this project turned out and the opportunity to contribute to such an innovative space.it’s important to note that the website is owned and copyrighted by Aurea CV OÜ."
,
    image:
      "https://i.ibb.co.com/wh0QQzw/Learncoin.png",
    tags: [
      "HTMl",
      "CSS",
      "Tailwind CSS",
      "Javascript",
      "React Js",
      "Next Js",
      "SEO",
      "Content Writing",
      "Contentful",
      "Vercel",
    ],
    category: "react js",
    github: "#",
    webapp: "https://learncoin-project.vercel.app/",
  },
  {
    id: 3,
    title: "Yamila Coach",
    date: "July 2024 - September 2024",
    description:
      "I had the privilege of developing the Yamila Coach website (https://yamila.coach) from start to finish, handling everything from the front end and back end to SEO and content writing. The project was built using React.js with Create React App, allowing me to create a modern, responsive, and interactive user interface. For the backend, I implemented Strapi as the headless CMS, ensuring smooth content management and flexibility for future scalability. Beyond the technical aspects, I also focused heavily on SEO, optimizing the website structure and content to improve visibility on search engines and drive organic traffic. Additionally, I crafted SEO-friendly, high-quality content that aligns perfectly with the brand’s identity, ensuring it communicates effectively with the target audience. Every detail, from performance tuning to designing an intuitive user experience, was carefully planned and executed to deliver a website that meets the client’s vision and goals. Although I developed all aspects of this project, it’s important to note that the website is owned and copyrighted by Yamila Coach and Aurea CV OÜ.",
    image:
      "https://i.ibb.co.com/hDkCtLB/Screenshot-1.png",
    tags: [
      "HTMl",
      "CSS",
      "Tailwind CSS",
      "Javascript",
      "React Js",
      "SEO",
      "Content Writing",
      "Strapi",
      "Netlify",
    ],
    category: "react js",
    github: "#",
    webapp: "https://yc-website-project.netlify.app",
  },
  {
    id: 9,
    title: "Tasty Pavilion",
    date: "Jun 2023 - Jul 2023",
    description:
      "Welcome to Tasty Pavilion, where culinary artistry meets modern innovation! Our website is not just a portal to a restaurant; it's an immersive journey into a world of delectable flavors, enticing aromas, and unforgettable dining experiences. Crafted with the latest technologies including React JS, Node JS, MongoDB, Firebase, Express JS, and Tailwind CSS, Tasty Pavilion represents the epitome of seamless digital integration and user-centric design.",
    image: "https://i.ibb.co/P5yDzM9/Screenshot-1.png",
    tags: [
      "HTMl",
      "CSS",
      "Tailwind CSS",
      "Javascript",
      "Eslint",
      "Netlify",
      "React Js",
      "MongoDb",
      "Node Js",
      "Express Js",
      "Firebase",
    ],
    category: "react js",
    github: "https://github.com/rahmantamim11/tasty-pavilion-client",
    webapp: "https://tasty-pavilion.netlify.app",
  },
  {
    id: 0,
    title: "Music Lounge",
    date: "Jan 2024 - Feb 2024",
    description:
      "Welcome to Music Lounge, your digital sanctuary for all things music! Our website isn't just a platform; it's a gateway to a world of melodies, rhythms, and harmonies that captivate the soul.Built using cutting-edge technologies including Next JS and Aceternity UI, Music Lounge embodies the perfect blend of sleek design and seamless functionality. Immerse yourself in an expansive library of tunes spanning genres, eras, and moods. From chart-topping hits to hidden gems waiting to be discovered, our curated collection caters to every musical taste and preference.",
    image: "https://i.ibb.co/X4yzrrW/Screenshot-2.png",
    tags: [
      "HTMl",
      "CSS",
      "Tailwind CSS",
      "Javascript",
      "Eslint",
      "Netlify",
      "React Js",
      "Next Js",
      "Typescript",
      "Vercel",
      "Aceternity UI",
    ],
    category: "next js",
    github: "https://github.com/rahmantamim11/music-lounge-nextjs",
    webapp: "https://music-lounge-nextjs.vercel.app/",
  },
  {
    id: 1,
    title: "Car Doctor",
    date: "Oct 2023 - Nov 2023",
    description:
      "Welcome to Car Doctor, your one-stop solution for all your car repair needs! Our website, meticulously crafted with React JS, Node JS, MongoDB, Firebase, Express JS, and Tailwind CSS, offers a seamless experience for car owners seeking reliable and efficient automotive services. From routine maintenance to complex repairs, our team of skilled professionals is dedicated to diagnosing and fixing any issue with precision and care.",
    image: "https://i.ibb.co/wQtYMCY/Screenshot-3.png",
    tags: [
      "HTMl",
      "CSS",
      "Tailwind CSS",
      "Javascript",
      "Eslint",
      "Netlify",
      "React Js",
      "MongoDb",
      "Node Js",
      "Express Js",
      "Firebase",
    ],
    category: "react js",
    github: "https://github.com/rahmantamim11/car-doctor-client",
    webapp: "https://car-doctor-101.netlify.app/",
  },
  {
    id: 2,
    title: "Wellness Vista",
    date: "Nov 2023 - Dec 2023",
    description:
      "Welcome to Wellness Vista, your trusted online destination for comprehensive medical care and holistic wellness solutions. Powered by React JS and Tailwind CSS, our website offers a seamless and intuitive experience for individuals seeking personalized healthcare services. From scheduling appointments with experienced healthcare professionals to accessing valuable resources on health education and wellness tips, Wellness Vista is committed to promoting your overall well-being.",
    image: "https://i.ibb.co/Ntdq6fj/Screenshot-4.png",
    tags: [
      "HTMl",
      "CSS",
      "Tailwind CSS",
      "Javascript",
      "React Js",
      "Eslint",
      "Vercel",
    ],
    category: "react js",
    github: "https://github.com/rahmantamim11/medical-website",
    webapp: "https://medical-website-rahman-tamim.vercel.app/",
  },
];
